import { checkBrowser } from '@/plugin/channel/setUserChannel'
/**
 * 文本高亮
 * @param {string} text 原文本
 * @param {string} keyword 需要高亮的关键字
 * @param {string} color 显示的颜色
 * @return {string} 高亮的HTML
 */
export const highlightText = function (text, keyword, color) {
  if (!keyword) {
    return text
  }
  const regex = new RegExp(keyword, 'gi')
  return text.replace(regex, match => `<span style=color:${color || '#ff9000'}>${match}</span>`)
}

// 防抖
export const debounce = function (fn, times = 500) {
  // 定义一个定时器来来记录上一次的定时器函数的状态
  let timer = null
  // 2 在接受这两个值时需要返回一个函数  (真正需要执行的函数)
  const _debounce = function (...args) { // 这里处理args传递的参数
    // 3 在处理防抖时 需要只执行一次 这里需要一个计时器
    // 4 计时器有一个返回的id属性值 ,利用返回的id,让函数只执行最后一次
    // 5 如果有这个id 则取消上一次计时器
    if (timer) clearInterval(timer) // 取消上一次定时器
    timer = setTimeout(() => { // 延迟执行
      fn.apply(this, args) // 外部传入的函数
      // 在这里重新绑定this(不绑定this指向的是windows =>这里改变this重新指向调用者input)
    }, times)
  }
  return _debounce
  // 问题: 主函数需要先执行 ,只不过返回的是undefined
  // undefined 游览器自己处理不做判断
}

// 前往寄件（抽取） tabActive国内 港澳台 国际
export const gotoSendMail = function (frontVueChannel, tabActive) {
  const NODE_ENV = process.env.VUE_APP_NODE_ENV
  const channel = checkBrowser()
  const sacToken = localStorage.getItem('NEW-GENERATION-API-TOKEN') || sessionStorage.getItem('NEW-GENERATION-API-TOKEN')
  const baseProjectDir = `https://ump.ems.com.cn/newmail-${NODE_ENV === 'production' ? 'api' : 'release'}`
  // const frontVueChannel = checkFrontVueChannel()
  const wxAppletObj = {
    land: '/pages/place_order/order?pageflag=0',
    // sar: '/packageC/pages/internationalOrder/internationalOrder?origin=sar&orderType=2', // WebView
    // int: '/packageC/pages/internationalOrder/internationalOrder?origin=int&orderType=2' // WebView
    sar: '/packageA/pages/internationalOrder/internationalOrder',
    int: '/packageA/pages/internationalOrder/internationalOrder?internation=true'
  }
  const alipayH5Obj = {
    land: 'pages/newOrder/newOrder' + encodeURIComponent('?sendType=1'),
    sar: 'pages/newWebView/newWebView' + encodeURIComponent('?type=7&orderType=2'),
    int: 'pages/newWebView/newWebView' + encodeURIComponent('?type=8&orderType=2')
  }
  const alipayAppletObj = {
    land: '/pages/newOrder/newOrder?sendType=1',
    sar: '/pages/newWebView/newWebView?type=7&orderType=2',
    int: '/pages/newWebView/newWebView?type=8&orderType=2'
  }
  const appJsonObj = {
    land: '{"jumpPath":"deliveryManAtYourDoor"}',
    sar: '{"jumpPath":"newInternationalOrder", "type":"1"}',
    int: '{"jumpPath":"newInternationalOrder", "type":"3"}'
  }
  const H5OrderPageObj = {
    land: `${baseProjectDir}/express/order/index.html#/order/create?channel=${channel}&sacToken=${sacToken}`,
    sar: `${baseProjectDir}/expandMenu/internation/index.html#/index/sar?channel=${channel}&sacToken=${sacToken}`,
    int: `${baseProjectDir}/expandMenu/internation/index.html#/index/int?channel=${channel}&sacToken=${sacToken}`
  }
  if (+frontVueChannel === 2) {
    // 微信小程序h5
    wx.miniProgram.navigateTo({
      url: wxAppletObj[tabActive]
    })
    return
  }
  if (+frontVueChannel === 3) {
    // 3支付宝公众号h5
    const appId = '2019053165350883'
    window.location.href = `alipays://platformapi/startapp?appId=${appId}&page=${alipayH5Obj[tabActive]}`
    return
  }
  if (+frontVueChannel === 4) {
    // 4支付宝小程序h5
    // eslint-disable-next-line no-undef
    my.navigateTo({
      url: alipayAppletObj[tabActive]
    })
  }
  if (+frontVueChannel === 5) {
    // 5APP
    window.location.href = `cnemsappintentpage://ems.com.cn?json=${appJsonObj[tabActive]}`
  }
  if (+frontVueChannel === 6) {
    // 6其他渠道
    window.location.href = H5OrderPageObj[tabActive]
  }
}

/**
 * 浮点数计算工具类
 * 解决 JavaScript 浮点数精度问题
 */
class FloatCalculator {
  /**
   * 获取数字的小数位数
   */
  static getDecimalLength (num) {
    try {
      // 处理科学计数法
      const numStr = num.toString()
      if (numStr.includes('e')) {
        const match = numStr.match(/\d(?:\.(\d*))?e([+-]\d+)/)
        if (match) {
          const decimals = match[1] ? match[1].length : 0
          const exponent = parseInt(match[2])
          return Math.max(0, decimals - exponent)
        }
      }

      // 普通数字
      const decimalPart = numStr.split('.')[1]
      return decimalPart ? decimalPart.length : 0
    } catch (error) {
      return 0
    }
  }

  /**
   * 将浮点数转换为整数
   */
  static floatToInt (num) {
    const decimalLength = this.getDecimalLength(num)
    const multiplier = Math.pow(10, decimalLength)
    return {
      int: Math.round(num * multiplier),
      multiplier: multiplier
    }
  }

  /**
   * 检查是否在安全整数范围内
   */
  static isSafeNumber (num) {
    return Math.abs(num) <= Number.MAX_SAFE_INTEGER
  }
}

/**
 * 精确计算类
 */
export class PreciseCalculation {
  /**
   * 加法
   */
  static add (...numbers) {
    if (numbers.length < 2) {
      throw new Error('至少需要两个参数')
    }

    return numbers.reduce((acc, curr) => {
      const maxDecimal = Math.max(
        FloatCalculator.getDecimalLength(acc),
        FloatCalculator.getDecimalLength(curr)
      )
      const multiplier = Math.pow(10, maxDecimal)
      if (!FloatCalculator.isSafeNumber(acc * multiplier) ||
          !FloatCalculator.isSafeNumber(curr * multiplier)) {
        throw new Error('数字超出安全计算范围')
      }
      return (acc * multiplier + curr * multiplier) / multiplier
    })
  }

  /**
   * 减法
   */
  static subtract (a, b, ...rest) {
    if (rest.length > 0) {
      return this.subtract(this.subtract(a, b), ...rest)
    }

    const maxDecimal = Math.max(
      FloatCalculator.getDecimalLength(a),
      FloatCalculator.getDecimalLength(b)
    )
    const multiplier = Math.pow(10, maxDecimal)
    if (!FloatCalculator.isSafeNumber(a * multiplier) ||
        !FloatCalculator.isSafeNumber(b * multiplier)) {
      throw new Error('数字超出安全计算范围')
    }
    return (a * multiplier - b * multiplier) / multiplier
  }

  /**
   * 乘法
   */
  static multiply (...numbers) {
    if (numbers.length < 2) {
      throw new Error('至少需要两个参数')
    }
    return numbers.reduce((acc, curr) => {
      const accDecimal = FloatCalculator.getDecimalLength(acc)
      const currDecimal = FloatCalculator.getDecimalLength(curr)
      const totalDecimal = accDecimal + currDecimal
      const accInt = FloatCalculator.floatToInt(acc)
      const currInt = FloatCalculator.floatToInt(curr)
      const result = (accInt.int * currInt.int) / Math.pow(10, totalDecimal)
      if (!FloatCalculator.isSafeNumber(result)) {
        throw new Error('乘法结果超出安全范围')
      }
      return result
    })
  }

  /**
   * 除法
   */
  static divide (a, b, ...rest) {
    if (rest.length > 0) {
      return this.divide(this.divide(a, b), ...rest)
    }

    if (b === 0) {
      throw new Error('除数不能为零')
    }

    const aDecimal = FloatCalculator.getDecimalLength(a)
    const bDecimal = FloatCalculator.getDecimalLength(b)
    const maxDecimal = Math.max(aDecimal, bDecimal)
    const multiplier = Math.pow(10, maxDecimal)
    const result = (a * multiplier) / (b * multiplier)
    if (!FloatCalculator.isSafeNumber(result)) {
      throw new Error('除法结果超出安全范围')
    }
    return result
  }

  /**
   * 四舍五入
   */
  static round (num, decimalPlaces = 0) {
    if (decimalPlaces < 0) {
      throw new Error('小数位数不能为负数')
    }

    const multiplier = Math.pow(10, decimalPlaces)
    return Math.round(num * multiplier) / multiplier
  }

  /**
   * 格式化金额（分转元）
   */
  static formatCurrency (fen, decimalPlaces = 2) {
    return this.divide(fen, 100).toFixed(decimalPlaces)
  }

  /**
   * 比较两个浮点数是否相等（在精度范围内）
   */
  static isEqual (a, b, precision = 0.000001) {
    return Math.abs(a - b) < precision
  }
}
